window.theme = window.theme || {};

$(document).on('click', '[data-icon-wishlist]', function (e) {
  e.preventDefault();

  const { themeWishlist } = window;

  const self = $(this);
  const productId = self.data('id');
  const ProductHandle = self.data('product-handle');
  let idxArr = themeWishlist.indexOf(ProductHandle);

  if (!self.hasClass('whislist-added')) {
    self.addClass('whislist-added');

    themeWishlist.push(ProductHandle);
    localStorage.setItem('items', JSON.stringify(themeWishlist));
  } else {
    self.removeClass('whislist-added');

    if ($('[data-wishlist-added="wishlist-' + productId + '"]').length) {
      $('[data-wishlist-added="wishlist-' + productId + '"]').remove();
    }

    themeWishlist.splice(idxArr, 1);
    localStorage.setItem('items', JSON.stringify(themeWishlist));
  }

  const wishlistElm = $(`[data-product-handle="${ProductHandle}"]`);
  idxArr = themeWishlist.indexOf(ProductHandle);

  if (idxArr >= 0) {
    wishlistElm.addClass('whislist-added');
  } else {
    wishlistElm.removeClass('whislist-added');
  }

  window.updateWishListIcon();
  window.updateWishListButtons();
});

window.updateWishListIcon = function () {
  if (themeWishlist.length === 0) {
    $('#wishlist-desktop .wishlist-quantity').remove();
    return;
  }

  const counter = `<span class="countPill wishlist-quantity" data-wishlits-count="">${themeWishlist.length}</span>`;
  $('#wishlist-desktop .wishlist-info').append(counter);
};

window.updateWishListButtons = function () {
  const { themeWishlist } = window;

  if (!themeWishlist.length) {
    return;
  }

  for (var i = 0; i < themeWishlist.length; i++) {
    $(`[data-product-handle="${themeWishlist[i]}"]`).addClass('whislist-added');
  }
};

function wishlistPage() {
  if (typeof Storage !== 'undefined' && $('.page').hasClass('page-wishlist')) {
    const { themeWishlist } = window;

    if (!themeWishlist.length) {
      return;
    }

    themeWishlist.forEach(function (item) {
      jQuery.getJSON(`/products/${item}.js`, function (product) {
        let productHTML = '';

        productHTML += `<tr class="wishlist_row" data-wishlist-added="wishlist-${product.id}" data-product-id="product-${product.handle}">`;
        productHTML += '<th class="wishlist_col wishlist_image text-center">';
        productHTML += `<a href="${product.url}" class="product-grid-image" data-collections-related="/collections/all?view=related">`;
        productHTML += `<img src="${product.featured_image}">`;
        productHTML += '</a></th>';
        productHTML += '<th class="wishlist_col wishlist_name text-left">';
        productHTML += '<div class="product-vendor">';
        productHTML += `<a href="/collections/vendors?q=${product.vendor}" title="${product.vendor}">${product.vendor}</a></div>`;
        productHTML += `<a class="product-title" href="${product.url}" title="${product.title}">${product.title}</a></th>`;
        productHTML += `<th class="wishlist_col wishlist_price text-center"><div class="product-price"><span class="price-item">${theme.Currency.formatMoney(
          product.price_min,
          theme.moneyFormat,
        )}</span></div></th>`;
        productHTML += `<th class="wishlist_col wishlist_remove text-center"><a class="btn btn--secondary product-remove whislist-added" href="#" data-product-handle="${product.handle}" data-icon-wishlist data-id="${product.id}"><span class="icon icon--big">&#215;</span>${theme.strings.remove}</a></th>`;
        productHTML += '<th class="wishlist_col wishlist_add text-center">';
        productHTML += `<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-${product.id}" data-id="product-actions-${product.id}" enctype="multipart/form-data">`;
        if (product.available) {
          if (product.variants.length == 1) {
            productHTML += `<button class="btn btn--secondary-accent" type="submit" data-btn-addToCart data-form-id="#wishlist-product-form-${product.id}">${theme.strings.addToCart}</button><input type="hidden" name="id" value="${product.variants[0].id}" />`;
          }
          if (product.variants.length > 1) {
            productHTML += `<a class="btn btn--secondary-accent" title="${product.title}" href="${product.url}">${theme.strings.select_options}</a>`;
          }
        } else {
          productHTML += `<button class="btn product-btn product-btn-soldOut" type="submit" disabled>${theme.strings.unavailable}</button>`;
        }

        productHTML += '</form></th>';
        productHTML += '</tr>';

        $('[data-wishlist-container]').append(productHTML);
      });

      window.Currency.convertAll(window.Shopify.currency.active, window.Currency.cookie.read());
    });

    // initWishListPagging
    setTimeout(function () {
      const wlpaggingContainer = $('#wishlist_pagination');
      const paggingTpl = `<li><a href="#" class="btn btn--narrow btn--prev disabled"><span class="icon_text">${theme.strings.previous}</span></a></li>`;
      const wishListCotainer = $('[data-wishlist-container]');

      wlpaggingContainer.children().remove();

      const totalPages = Math.ceil(themeWishlist.length / 5);

      if (totalPages <= 1) {
        wishListCotainer.children().show();
        return;
      }

      for (let i = 0; i < totalPages; i++) {
        const pageNum = i + 1;
        if (i === 0)
          paggingTpl += `<li><a class="pagination-link pagination--current" data-page="${pageNum}" href="${pageNum}" title="${pageNum}">${pageNum}</a></li>`;
        else
          paggingTpl += `<li><a class="pagination-link" data-page="${pageNum}" href="${pageNum}" title="${pageNum}">${pageNum}</a></li>`;
      }

      paggingTpl += `<li><a class="btn btn--narrow btn--next" href="#"><span class="icon_text">${theme.strings.next}</span></a></li>`;

      wlpaggingContainer.append(paggingTpl);

      wishListCotainer.children().each(function (idx, elm) {
        if (idx >= 0 && idx < 5) {
          $(elm).show();
        } else {
          $(elm).hide();
        }
      });

      wlpaggingContainer.off('click.wl-pagging').on('click.wl-pagging', 'li a', function (e) {
        e.preventDefault();

        const isPrev = $(this).hasClass('btn--prev');
        const isNext = $(this).hasClass('btn--next');
        const pageNumber = $(this).data('page');

        if (isPrev) {
          const curPage = parseInt($('#wishlist_pagination').find('.pagination--current').data('page'));
          pageNumber = curPage - 1;
        }

        if (isNext) {
          const curPage = parseInt($('#wishlist_pagination').find('.pagination--current').data('page'));
          pageNumber = curPage + 1;
        }

        wishListCotainer.children().each(function (idx, elm) {
          if (idx >= (pageNumber - 1) * 5 && idx < pageNumber * 5) {
            $(elm).show();
          } else {
            $(elm).hide();
          }
        });

        if (pageNumber === 1) {
          wlpaggingContainer.find('.btn--prev').addClass('disabled');
          wlpaggingContainer.find('.btn--next').removeClass('disabled');
        } else if (pageNumber === totalPages) {
          wlpaggingContainer.find('.btn--next').addClass('disabled');
          wlpaggingContainer.find('.btn--prev').removeClass('disabled');
        } else {
          wlpaggingContainer.find('.btn--prev').removeClass('disabled');
          wlpaggingContainer.find('.btn--next').removeClass('disabled');
        }

        $('#wishlist_pagination').find('.pagination-link').removeClass('pagination--current');
        $('#wishlist_pagination').find(`[data-page="${pageNumber}"]`).addClass('pagination--current');
      });
    }, 1000);
  }
}

window.themeWishlist = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];

$(document).ready(function () {
  window.updateWishListIcon();
  window.updateWishListButtons();
  wishlistPage();
});
